module.exports = __webpack_public_path__ + "img/56.fae4946b.jpg";